import { Row } from 'antd';

export const FilterBar = ({ children, className = "" }) => (
  <div className={`pcu-bg-white pcu-border pcu-radius-12 pcu-padding-16 pcu-margin-bottom-16 pcu-shadow-xs ${className}`}>
    <Row gutter={[16, 16]} align="bottom">
      {children}
    </Row>
  </div>
);

export const SecondaryFilterBar = ({ children, className = "" }) => (
  <div className={`pcu-margin-bottom-16 ${className}`}>
    <Row gutter={[16, 16]} align="bottom">
        {children}
    </Row>
  </div>
);
